export const SURVEY_DEMO = "SURVEY_DEMO"
export const CREATE_SURVEY_DEMO = "CREATE_SURVEY_DEMO"